<div class="wtn-cta">
    <div class="wtn-cta-img">
        <img src="/assets/images/wtn-logo-cta.png" />
    </div>
    <div class="wtn-cta-action">
        <button nbButton [routerLink]="['/wtn/wtn-rating']" status="primary" [size]="buttonSize">
            {{ "WTN.CTA.BUTTON" | translate }} <nb-icon icon="arrow-forward-outline"></nb-icon>
        </button>
    </div>
</div>
